import { Button, Flex, HStack } from '@chakra-ui/react';
import { FC } from 'react';
import { Icon } from '@app/components/Icon';
import styles from './CartButton.module.scss';
import { useCartStore } from '@app/state/nftCartStore';
import { CheckoutModal } from '@app/screens/nft-marketplace/Cart/CheckoutModal';
import { useToggle } from 'react-use';
import { useNftCartModal } from '@app/context/NftCartContext';

type Props = {};

export const CartButton: FC<Props> = () => {
  const { cartItems } = useCartStore();
  const { toggleModal } = useNftCartModal();

  return (
    <Button
      backgroundColor="whiteOpacity.13"
      borderRadius="8px"
      padding="8px 14px"
      alignItems="center"
      fontWeight="500"
      minWidth="110px"
      width={['100%', '100px']}
      size="16px"
      lineHeight="26px"
      justifyContent="center"
      gap="4px"
      _hover={{ backgroundColor: 'gray.15' }}
      onClick={() => toggleModal(true)}
    >
      <Icon className={styles.icon} name="cartFilled" />
      <span>{`Cart: ${cartItems.length}`}</span>
    </Button>
  );
};
